import Button from '@/components/Button';

const ProductMenu = ({ products, formulas, onProductClick }) => {
    // Combine products and formulas into a single items list
    const items = [...products, ...formulas];

    return (
        <div className="bg-white rounded-xl shadow-lg p-8 mx-4 mx-auto">
            <div id="sidebar-content" className={`grid grid-cols-2 ${window.innerHeight > 568 ? 'h-[280px]' : 'h-[100px]'} md:grid-cols-3 gap-4 overflow-x-hidden overflow-y-auto md:h-auto lg:h-[480px]`}>
                {items.map((item) => (
                    <div key={item.id} className="flex flex-col justify-between items-center" onClick={() => onProductClick(item)}>
                        <img
                            src={item.picture}
                            alt={item.name}
                            className="w-[120px] h-24 object-cover rounded-md mb-4 md:w-[150px] md:h-[150px]"
                            style={{ borderRadius: '22px', objectFit: 'cover' }}
                        />
                        <h3 className="text-md leading-none font-bold text-center md:text-lg">{item.name}</h3>
                        <p className="text-gray-600 text-center">{item.price} €</p>
                        {formulas.includes(item) && (
                            <Button
                                text={'Voir le contenu'}
                                type={'Button'}
                                action={'button'}
                                handleClick={() => onProductClick(item)}
                                disabled={true}
                                withTopMargin={false}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductMenu;
